module.exports = __webpack_public_path__ + "img/file-invoice-dollar.69052305.svg";